import ExitIcon from "../../shared/Icons/ExitIcon";
import Typography from "../../shared/typography/Typography";

import { Container, IconContainer } from "./style";

interface IProps {
  onRemove: () => void;
  onSelect: () => void;
  title: string;
  selected: boolean;
}

export const Tag = ({onRemove, title, onSelect, selected}: IProps) => {
  return(
    <Container onClick={onSelect} selected={selected}>
      <Typography color={selected ? "primary" : "placeholder"} type="buttonXS">{title}</Typography>
      <IconContainer onClick={onRemove}>
        <ExitIcon color={selected ? "primary" : "label"} colorHover={selected ? "primaryDark" : "body"} />
      </IconContainer>
    </Container>
  );
}